module.exports = __webpack_public_path__ + "static/gatsby-portfolio-thumb-31fcde318c4215c91dea3278a63bbe5a.jpg";